import React from 'react';
import cn from 'classnames';
import propTypes from 'prop-types';

import Edit from '../Assets/Svgs/Edit';

function EditColorsButton({ onChange, isCircle }) {
  return (
    <button
      className={cn('button', { circle: isCircle })}
      type="button"
      onClick={onChange}
      aria-label="Edit colors"
    >
      <Edit className="button-icon" title="Remove" />
    </button>
  );
}

EditColorsButton.propTypes = {
  onChange: propTypes.func.isRequired,
  isCircle: propTypes.bool,
};

EditColorsButton.defaultProps = {
  isCircle: false,
};

export default EditColorsButton;
